// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1g5Lv","options":"AnswerScale_options__A6hZw","selected":"AnswerScale_selected__1kSV0"};